import onLoadShared from "../shared/on_load"
onLoadShared.run()

import onLoad from "../sites/benlieb/on_load"
onLoad.run()
